
<div>
    <Modal
        ref="modal-appointment"
        id="modal-appointment"
        :size="'md'"
        v-if="show"
        @close="hide()"
    >
        <div slot="header" class="d-block">
            <div class="p-3 header-sidebar">
                <div class="col-12" style="z-index: 999" @click="hide()">
                    <img v-img-prefix class="img-close float-right" :src="`/public-assets/close-modal`"
                         alt="close-modal"/>
                </div>
            </div>
        </div>
        <div slot="body" class="d-block">
            <div class="container">
                <div class="row">
                    <div class="col-12 appointment-title">
                        <span class="circle-blue">1</span> Selecciona una sucursal
                    </div>
                    <div class="col-12 store-name">
                        {{ location.title }}
                    </div>
                    <div class="col-12 store-details txt-blue">
                        En una sucursal {{ location.store }}
                    </div>
                    <div class="col-12 store-details">
                        {{ location.address }}
                        <hr/>
                    </div>
                    <div
                        class="col-12 alert alert-warning"
                        v-if="
            getDistanceFromLatLonInKm(
              positions.coords.latitude,
              positions.coords.longitude,
              location.lat,
              location.lng
            ).toFixed(2) > 3 && calendar
          "
                    >
                        Esta sucursal se encuentra muy lejos de tu ubicación.
                    </div>
                </div>
                <div class="row" v-show="!loading && calendar">
                    <div class="col-12 appointment-title">
                        <span class="circle-blue">2</span> Selecciona un día y una hora
                    </div>
                    <div class="col-12">
                        <dayPicker
                            v-if="calendar != null"
                            :calendar="calendar"
                            :setDate="setDate"
                            :date="date"
                        ></dayPicker>
                        <hr/>
                    </div>
                </div>
                <div class="row" v-show="!loading && !calendar">
                    <div class="col-12 appointment-title">
                        No hay citas disponibles para esta sucursal
                    </div>
                </div>
                <div
                    class="row text-center hours-container"
                    v-if="!loading && date != null"
                >
                    <div
                        class="col-12 py-2 hour-container"
                        v-for="(hour, index) in hours"
                        :key="`hour${index}`"
                        @click="time = hour"
                        :class="time === hour ? 'active' : ''"
                    >
                        {{ formatTime(hour) }}
                    </div>
                    <div class="col-12">
                        {{ hours.length === 0 ? "No hay horarios disponibles" : "" }}
                        <hr/>
                    </div>
                </div>
                <div class="row" v-if="!loading && time != null">
                    <div class="col-12 mt-3 appointment-title">
                        <span class="circle-blue">3</span> Agenda tu cita
                    </div>
                    <div
                        class="sucursal-appointment text-center col-12 mt-3"
                        v-if="!creating"
                    >
                        <button
                            class="btn scheudleButton"
                            @click.prevent="rescheduleAppointment(location)"
                        >
                            FINALIZAR
                        </button>
                    </div>
                    <div class="col-12 text-center" v-else>
                        <div class="spinner-border text-primary mx-auto" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="loading">
                    <div class="spinner-border text-primary mx-auto" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</div>
